var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 18.6663C2.66675 14.9211 2.66675 13.0485 3.56557 11.7033C3.95469 11.121 4.45469 10.621 5.03704 10.2318C6.38223 9.33301 8.25485 9.33301 12.0001 9.33301H20.0001C23.7453 9.33301 25.6179 9.33301 26.9631 10.2318C27.5454 10.621 28.0454 11.121 28.4346 11.7033C29.3334 13.0485 29.3334 14.9211 29.3334 18.6663C29.3334 22.4115 29.3334 24.2842 28.4346 25.6294C28.0454 26.2117 27.5454 26.7117 26.9631 27.1009C25.6179 27.9997 23.7453 27.9997 20.0001 27.9997H12.0001C8.25485 27.9997 6.38223 27.9997 5.03704 27.1009C4.45469 26.7117 3.95469 26.2117 3.56557 25.6294C2.66675 24.2842 2.66675 22.4115 2.66675 18.6663Z",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 9.33333C21.3334 6.81917 21.3334 5.56209 20.5523 4.78105C19.7713 4 18.5142 4 16.0001 4C13.4859 4 12.2288 4 11.4478 4.78105C10.6667 5.56209 10.6667 6.81917 10.6667 9.33333",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.667L8.86929 14.9363C13.4468 16.355 18.5532 16.355 23.1307 14.9363L24 14.667M16 16.0003V18.667",
    stroke: "#7157C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkorder);
export default __webpack_public_path__ + "static/media/workorder.bd3c91dccb8b08663b0718117dd0b687.svg";
export { ForwardRef as ReactComponent };